import { render } from "./LongPopUpNotification.vue?vue&type=template&id=79209815&scoped=true"
import script from "./LongPopUpNotification.vue?vue&type=script&lang=js"
export * from "./LongPopUpNotification.vue?vue&type=script&lang=js"

import "./LongPopUpNotification.vue?vue&type=style&index=0&id=79209815&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79209815"

export default script